import { NgTemplateOutlet } from '@angular/common';
import { Component, inject, Input, output } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import type { IconName } from '@core/user-interface-legacy';
import { ButtonComponent, IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-walkthrough-dialog-footer',
  imports: [ButtonComponent, IconComponent, NgTemplateOutlet],
  templateUrl: './walkthrough-dialog-footer.component.html',
  styleUrl: './walkthrough-dialog-footer.component.less',
})
export class WalkthroughDialogFooterComponent {
  public i18n = inject(I18nService);

  @Input() public currentStep: number;
  @Input() public stepsTotal: number;

  @Input() public ofText: string;
  @Input() public ctaText: string;
  @Input() public ctaIcon?: IconName = undefined;
  @Input() public closeText: string;
  @Input() public closeIcon: IconName | undefined;
  @Input() public displayCtaOnly: boolean = false;
  @Input() public learnMoreText: string = this.i18n.translate('app.common.learn_more');
  @Input() public dialogHelpArticle: string;

  public cancel = output<void>();
  public start = output<void>();
}
